import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttach = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_13967_75668)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.6666 4.49828L10.6666 11.5516C10.6666 12.9449 9.64658 14.1849 8.25992 14.3183C6.67325 14.4716 5.33325 13.2249 5.33325 11.6649L5.33325 3.42494C5.33325 2.55161 5.95992 1.75828 6.82658 1.67161C7.82658 1.57161 8.66658 2.35161 8.66658 3.33161L8.66658 10.3316C8.66658 10.6983 8.36658 10.9983 7.99992 10.9983C7.63325 10.9983 7.33325 10.6983 7.33325 10.3316L7.33325 4.49828C7.33325 4.22494 7.10658 3.99828 6.83325 3.99828C6.55992 3.99828 6.33325 4.22494 6.33325 4.49828L6.33325 10.2383C6.33325 11.1116 6.95992 11.9049 7.82658 11.9916C8.82658 12.0916 9.66658 11.3116 9.66658 10.3316L9.66658 3.44494C9.66658 2.05161 8.64658 0.811611 7.25992 0.678278C5.66658 0.524945 4.33325 1.77161 4.33325 3.33161L4.33325 11.5116C4.33325 13.4249 5.73325 15.1383 7.63992 15.3183C9.83325 15.5183 11.6666 13.8116 11.6666 11.6649L11.6666 4.49828C11.6666 4.22494 11.4399 3.99828 11.1666 3.99828C10.8933 3.99828 10.6666 4.22494 10.6666 4.49828Z",
			fill: "#63688B"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13967_75668",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0 16) rotate(-90)"
		})
	}) })]
});
export default SvgAttach;
